/*
 *
 * Do not edit directly
 * Generated on Fri, 11 Jul 2025 22:14:40 GMT
 *
 */

import PaletteIconCheckmark from '@telus-uds/palette-allium/build/rn/icons/Checkmark'
const theme = {
  appearances: {},
  rules: [],
  tokens: {
    background: '#2c2e30',
    checkMarkFocusColor: '#676e73',
    checkMarkHeight: 24,
    checkMarkHoverColor: '#676e73',
    checkMarkIcon: PaletteIconCheckmark,
    checkMarkSelectedColor: '#ffffff',
    checkMarkUnselectedColor: 'rgba(0, 0, 0, 0)',
    checkMarkWidth: 24,
    padding: 16
  }
}
export default theme
